import React, { RefObject } from "react";

type Props = {
    label?: string;
};

const BasicFormElement = React.forwardRef((props: React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & Props, ref: RefObject<HTMLInputElement>) => {
    return (
        <div hidden={props.hidden}>
            {props.label && (
                <label
                    dangerouslySetInnerHTML={{
                        __html: props.label,
                    }}
                    htmlFor={props.id}
                    className="mb-2 block text-sm font-medium text-textColor"
                />
            )}
            <input
                id={props.id}
                ref={ref}
                className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500"
                {...props}
            />
        </div>
    );
});

BasicFormElement.displayName = "BasicFormElement";

export default BasicFormElement;